/* ═══════════════════════════════════════════════════════════════════════════
 * LES MÉTA-DONNÉES DES PAGES PUBLIQUES — POINT UNIQUE (lot visibilité, 14/10/2026)
 * ═══════════════════════════════════════════════════════════════════════════
 * ⚠️ CE FICHIER EST LU DEUX FOIS, ET C'EST TOUTE SA RAISON D'ÊTRE :
 *      ① par `scripts/prerendre.js`, qui écrit ces balises dans le HTML
 *        STATIQUE au moment du build — c'est ce qu'un robot reçoit ;
 *      ② par `src/seo/Seo.jsx`, qui les repose à chaque navigation SPA — c'est
 *        ce qu'un visiteur voit dans l'onglet et ce qu'un partage reprend.
 *    *Deux rédactions auraient divergé, et celle qu'on oublierait serait celle
 *    du robot — la seule que personne ne regarde jamais.*
 *
 * 🔴 CE QUE LA PRODUCTION SERVAIT AVANT CE LOT, MESURÉ LE 14/10/2026 : les SIX
 *    pages publiques rendaient **le même HTML de 1 592 octets** — un seul titre,
 *    une seule description, zéro JSON-LD, aucune `og:image`, et 130 caractères
 *    de texte dont « You need to enable JavaScript to run this app. »
 *    ➡️ Six pages, une seule fiche. Un moteur ne pouvait en distinguer aucune.
 *
 * ⛔ AUCUN « PREMIER » — décision de Dom. La description servie jusqu'ici
 *    annonçait « le premier ERP SaaS natif IA » : une affirmation de rang que
 *    rien n'établit, et qu'un concurrent peut contester. *On décrit ce que le
 *    produit FAIT ; on ne se classe pas soi-même.*
 *
 * ⓘ LES DESCRIPTIONS TIENNENT SOUS 160 CARACTÈRES, longueur au-delà de laquelle
 *   Google tronque. Le contrôle est fait par la recette, pas à l'œil.
 * ═══════════════════════════════════════════════════════════════════════════ */

export const SITE = 'https://gss360.net';
export const NOM_SITE = 'GSS-360';
export const LOCALE = 'fr_FR';
export const LANGUE = 'fr';

/* ⓘ L'IMAGE DE PARTAGE VIT DANS `public/`, et c'est ce qui la protège : tout ce
 *   que porte `public/` est recopié tel quel dans `build/` à chaque build. */
export const OG_IMAGE = `${SITE}/og-gss360.png`;
export const OG_IMAGE_LARGEUR = 1200;
export const OG_IMAGE_HAUTEUR = 630;

/* ⚠️ LES SIX ROUTES PUBLIQUES, ET ELLES SEULES. L'application connectée n'est
 *    PAS pré-rendue : son contenu dépend de qui regarde, et un HTML statique y
 *    serait au mieux faux, au pire la fiche d'un autre client. */
export const PAGES = [
  {
    chemin: '/',
    titre: 'GSS-360 — Logiciel de gestion pour sociétés de sécurité privée en zone OHADA',
    description: 'Pointage, paie, rondes, contrats et comptabilité SYSCOHADA dans une '
      + 'seule plateforme pour les sociétés de sécurité privée de la zone OHADA.',
    ogTitre: 'GSS-360 — Toute votre société de sécurité privée, pilotée depuis une seule plateforme',
  },
  {
    chemin: '/qui-sommes-nous',
    titre: 'Qui sommes-nous — GSS-360, par Gladiator Security Systems',
    /* ⓘ CETTE DESCRIPTION REPREND CELLE QUE LA PAGE POSAIT ELLE-MÊME avant ce
     *   lot (168 caractères, donc tronquée par Google). On garde ce qu'elle
     *   disait — une solution née du terrain — et on laisse le NOM DU FONDATEUR
     *   au corps de la page, où il est déjà écrit : une description est un
     *   résumé, pas une seconde fiche d'identité. */
    description: 'Gladiator Security Systems, éditeur de GSS-360 à Lomé : une solution '
      + 'née du terrain, pour les sociétés de sécurité privée d’Afrique francophone.',
    ogTitre: 'Qui sommes-nous — GSS-360',
  },
  {
    chemin: '/faq',
    titre: 'Questions fréquentes — GSS-360, logiciel de sécurité privée OHADA',
    description: 'Mise en service, reprise de vos données, paie multi-pays, tarifs et '
      + 'engagement : ce qu’il faut savoir avant de démarrer avec GSS-360.',
    ogTitre: 'Questions fréquentes — GSS-360',
  },
  {
    chemin: '/mentions-legales',
    titre: 'Mentions légales — GSS-360',
    description: 'Éditeur, siège social, hébergement et contact de la plateforme '
      + 'GSS-360, éditée par Gladiator Security Systems à Lomé, Togo.',
    ogTitre: 'Mentions légales — GSS-360',
  },
  {
    chemin: '/confidentialite',
    titre: 'Politique de confidentialité — GSS-360',
    description: 'Quelles données GSS-360 traite, pourquoi, combien de temps, où elles '
      + 'sont hébergées, et comment exercer vos droits.',
    ogTitre: 'Politique de confidentialité — GSS-360',
  },
  {
    chemin: '/legal',
    titre: 'Informations légales — GSS-360',
    description: 'Éditeur, siège social, conditions d’utilisation et contact de la '
      + 'plateforme GSS-360.',
    ogTitre: 'Informations légales — GSS-360',
  },
];

export const CHEMINS_PUBLICS = PAGES.map((p) => p.chemin);

/** La fiche d'une route, ou `null` si la route n'est pas publique. */
export function pageDe(chemin) {
  const net = chemin.length > 1 ? chemin.replace(/\/+$/, '') : chemin;
  return PAGES.find((p) => p.chemin === net) || null;
}

/* ═══════════════════════════════════════════════════════════════════════════
 * JSON-LD DE L'ACCUEIL — CE QUE L'ENTREPRISE EST, ET CE QUE LE PRODUIT EST
 * ═══════════════════════════════════════════════════════════════════════════
 * ⚠️ LES IDENTIFIANTS VIENNENT DU PIED DE PAGE, PAS D'AILLEURS. `RCCM
 *    TG-LFW-01-2024-B13-00449 · NIF 1001930788` et l'adresse sont déjà affichés
 *    sur la vitrine : les réécrire ici d'une autre source créerait deux vérités
 *    sur l'identité légale de la société.
 * ⛔ AUCUNE NOTE, AUCUN AVIS — décision de Dom. `aggregateRating` et `review`
 *    sont des déclarations que rien n'établit ; Google les sanctionne, et elles
 *    diraient au visiteur une satisfaction que personne n'a mesurée.
 * ⓘ LES PRIX SONT CEUX DE LA PAGE « Nos offres », en XOF, **sans TVA** —
 *   l'éditeur facture au réel sans TVA (décision du 13/09/2026, tenue par la
 *   base, le moteur et le PDF). Annoncer un prix hors taxes ici ferait attendre
 *   un supplément qui n'arrive jamais.
 */
export const ORGANISATION = {
  '@type': 'Organization',
  '@id': `${SITE}/#organisation`,
  name: 'Gladiator Security Systems - Togo',
  url: SITE,
  address: {
    '@type': 'PostalAddress',
    streetAddress: 'Tokoin-Wuiti, Rue Air-Burkina',
    addressLocality: 'Lomé',
    addressCountry: 'TG',
  },
  identifier: [
    { '@type': 'PropertyValue', name: 'RCCM', value: 'TG-LFW-01-2024-B13-00449' },
    { '@type': 'PropertyValue', name: 'NIF', value: '1001930788' },
  ],
};

export const APPLICATION = {
  '@type': 'SoftwareApplication',
  '@id': `${SITE}/#gss360`,
  name: 'GSS-360',
  applicationCategory: 'BusinessApplication',
  operatingSystem: 'Web',
  url: SITE,
  inLanguage: 'fr',
  publisher: { '@id': `${SITE}/#organisation` },
  /* ⓘ La zone OHADA, dite par ses dix-sept États membres plutôt que par un
   *   sigle : `areaServed` attend des lieux, et « OHADA » n'en est pas un. */
  areaServed: ['BJ', 'BF', 'CM', 'CF', 'KM', 'CG', 'CI', 'GA', 'GN', 'GW',
    'GQ', 'ML', 'NE', 'CD', 'SN', 'TD', 'TG'].map((c) => ({
    '@type': 'Country', identifier: c,
  })),
  offers: [
    { nom: 'ALPHA', prix: '40000' },
    { nom: 'VANGUARD', prix: '50000' },
    { nom: 'ELITE', prix: '150000' },
    { nom: 'ELITE+', prix: '240000' },
  ].map((o) => ({
    '@type': 'Offer',
    name: o.nom,
    price: o.prix,
    priceCurrency: 'XOF',
    /* ⓘ `UnitPriceSpecification` dit que le prix est MENSUEL et qu'il ne porte
     *   PAS de taxe — sans quoi « 40 000 » serait lu comme un prix unique. */
    priceSpecification: {
      '@type': 'UnitPriceSpecification',
      price: o.prix,
      priceCurrency: 'XOF',
      valueAddedTaxIncluded: false,
      billingDuration: 1,
      billingIncrement: 1,
      unitCode: 'MON',
    },
  })),
};

export function jsonLdAccueil() {
  return {
    '@context': 'https://schema.org',
    '@graph': [ORGANISATION, APPLICATION],
  };
}
